import module from './module.js'
// Componentes
import './components/component.js'
import './components/facturas/component.js'
import './components/facturas/factura/component.js'
import './components/informacion/component.js'
import './components/informacion/accionistas/component.js'
import './components/informacion/accionistas/agregar/component.js'
import './components/informacion/accionistas/editar/component.js'
import './components/informacion/accionistas/eliminar/component.js'
import './components/informacion/accionistas/lista/component.js'
import './components/informacion/accionistas/lista/item/component.js'
import './components/informacion/bancos/component.js'
import './components/informacion/bancos/agregar/component.js'
import './components/informacion/bancos/agregar/confirmacion/component.js'
import './components/informacion/bancos/documento/component.js'
import './components/informacion/bancos/documento/seleccionar/component.js'
import './components/informacion/bancos/documento/eliminar/component.js'
import './components/informacion/bancos/documento/eliminar/confirmacion/component.js'
import './components/informacion/bancos/editar/component.js'
import './components/informacion/bancos/editar/confirmacion/component.js'
import './components/informacion/bancos/lista/component.js'
import './components/informacion/bancos/lista/item/component.js'
import './components/informacion/bancos/eliminar/component.js'
import './components/informacion/bancos/eliminar/confirmacion/component.js'
import './components/informacion/contactos/component.js'
import './components/informacion/contactos/agregar/component.js'
import './components/informacion/contactos/lista/component.js'
import './components/informacion/contactos/lista/item/component.js'
import './components/informacion/contacto/informacion/component.js'
import './components/informacion/contacto/editar/component.js'
import './components/informacion/contacto/eliminar/component.js'
import './components/informacion/direcciones/component.js'
import './components/informacion/direccion/editar/component.js'
import './components/informacion/direcciones/lista/component.js'
import './components/informacion/direcciones/lista/item/component.js'
import './components/informacion/direcciones/agregar/component.js'
import './components/informacion/encargadospld/component.js'
import './components/informacion/encargadospld/agregar/component.js'
import './components/informacion/encargadospld/editar/component.js'
import './components/informacion/encargadospld/eliminar/component.js'
import './components/informacion/encargadospld/lista/component.js'
import './components/informacion/encargadospld/lista/item/component.js'
import './components/informacion/juridico/component.js'
import './components/informacion/juridico/documentos/component.js'
import './components/informacion/representante/component.js'
import './components/informacion/representante/editar/component.js'
import './components/informacion/representantes/component.js'
import './components/informacion/representantes/agregar/component.js'
import './components/informacion/atencion/component.js'
import './components/informacion/atencion/agregar/component.js'
import './components/informacion/atencion/agregar/confirmar/component.js'
import './components/informacion/atencion/editar/component.js'
import './components/informacion/atencion/editar/confirmar/component.js'
import './components/informacion/atencion/lista/component.js'
import './components/informacion/atencion/lista/item/component.js'
import './components/informacion/atencion/eliminar/component.js'
import './components/informacion/atencion/eliminar/confirmar/component.js'
// Servicios
import './services/Cliente.js'
import './services/Direcciones/Catalogo.js'
import './services/Facturas.js'
import './services/Facturas/Factura.js'
import './services/Informacion.js'
import './services/Informacion/Accionista.js'
import './services/Informacion/Accionistas.js'
import './services/Informacion/Bancos.js'
import './services/Informacion/Contacto.js'
import './services/Informacion/Contactos.js'
import './services/Informacion/Encargadopld.js'
import './services/Informacion/Encargadospld.js'
import './services/Informacion/Juridico.js'
import './services/Informacion/Bancos/Banco.js'
import './services/Informacion/Bancos/Documento.js'
import './services/Informacion/Bancos/Documento/Pdf.js'
import './services/Informacion/Juridico/Documentos.js'
import './services/Informacion/Representante.js'
import './services/Informacion/Representantes.js'
import './services/Informacion/AtencionClientes.js'
import './services/Informacion/AtencionCliente.js'
// Rutas
import './routes/informacion/contactos.js'
import './routes/cliente.js'
import './routes/factura.js'
import './routes/facturas.js'
import './routes/informacion.js'
import './routes/informacion/accionistas.js'
import './routes/informacion/bancos.js'
import './routes/informacion/bancos/agregar.js'
import './routes/informacion/encargadospld.js'
import './routes/informacion/juridico.js'
import './routes/informacion/accionistas/agregar.js'
import './routes/informacion/accionistas/editar.js'
import './routes/informacion/contactos/agregar.js'
import './routes/informacion/contactos/editar.js'
import './routes/informacion/direcciones.js'
import './routes/informacion/direcciones/agregar.js'
import './routes/informacion/direcciones/editar.js'
import './routes/informacion/encargadospld/agregar.js'
import './routes/informacion/encargadospld/editar.js'
import './routes/informacion/atencion.js'
import './routes/informacion/atencion/agregar.js'

export default module.name



// WEBPACK FOOTER //
// ./src/cliente/index.js